import { writable } from 'svelte/store';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

const createStatusBarStore = () => {
  const { subscribe, set } = writable('default');

  const setStyle = async (style) => {
    if (Capacitor.isNativePlatform()) {
      if (style === 'transparent') {
        await StatusBar.setStyle({ style: Style.Dark });
        await StatusBar.setBackgroundColor({ color: "#00000000" });
        await StatusBar.setOverlaysWebView({ overlay: true });
      } else {
        await setDefault();
      }
    }
    set(style);
  };

  const setDefault = async () => {
    if (Capacitor.isNativePlatform()) {
      await StatusBar.setStyle({ style: Style.Light });
      await StatusBar.setBackgroundColor({ color: "#FFFFFF" });
      await StatusBar.setOverlaysWebView({ overlay: false });
      if (Capacitor.getPlatform() === 'android') {
        await StatusBar.setTranslucent({ translucent: true });
      }
    }
    set('default');
  };

  const setTransparent = async () => {
    if (Capacitor.isNativePlatform()) {
      await StatusBar.setStyle({ style: Style.Dark });
      await StatusBar.setBackgroundColor({ color: "#00000000" });
      await StatusBar.setOverlaysWebView({ overlay: true });
    }
    set('transparent');
  };

  return {
    subscribe,
    setTransparent,
    setDefault,
  };
};

export const statusBarStyle = createStatusBarStore();